import {SET_PAYMENT_PENDING_COUNTER} from "../constans";

const defaultState = {
    paymentPendingAmount: 0,
};

const paymentPendingCountersReducer = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_PAYMENT_PENDING_COUNTER : return {
            ...state,
            paymentPendingAmount: payload.paymentPendingAmount,
        }; break;
        default: return state;
    }
}

export default paymentPendingCountersReducer;